import { usePageModalLocationState } from "@/modules/page-modal";

export const usePageModalNavigationItems = (itemId) => {
  const { backgroundList } = usePageModalLocationState();

  if (!itemId || !backgroundList?.length) return {};

  const currentIndex = backgroundList.findIndex(
    (item) => item.id === parseInt(itemId)
  );

  if (currentIndex === -1) return {};

  return {
    previousItem: backgroundList[currentIndex - 1],
    nextItem: backgroundList[currentIndex + 1],
  };
};
